import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Input, Select, DatePicker, Modal, Tag, Skeleton, Tooltip , Spin} from 'antd';
import { FaFileAlt, FaAnchor, FaTimes, FaSave } from 'react-icons/fa';
import FrmAddContract from '../func/FrmAddContract';
import FrmUpdateContract from '../func/FrmUpdateContract';
import TabCpn from '../func/TabCpn';
import { LoadingOutlined } from '@ant-design/icons';
import './../../../css/BadgeAnt.css'
import moment from 'moment';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
const { Option } = Select;

const CustomModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};


const CustomModalMenu = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-menu-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};



const MenuTraGop = () => {
    const [data, setData] = useState([]);
    const [isOpenTabMenu, setOpenTabMenu] = useState(false);
    const [isAddContract, setIsAddContract] = useState(false);
    const [isUpdateContract, setIsUpdateContract] = useState(false);
    const [modalContent, setModalContent] = useState({ tab: "1", id: null }); // New state to hold tab and id
    const [loading, setLoading] = useState(true); // Loading state for the skeleton
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [txtMaHD, setTxtMaHD] = useState('');
    const [txtTenKH, setTxtTenKH] = useState('');
    const [txtCMND, setTxtCMND] = useState('');
    const [txtPhone, setTxtPhone] = useState('');
    const [selectedCode, setSelectedCode] = useState("0");
    const [pageSize, setPageSize] = useState(10); // Số dòng hiển thị mặc định
    const [currentPage, setCurrentPage] = useState(1); // Trang hiện tại

    const [total_interest_predict, setTotal_interest_predict] = useState(0);
    const [total_debit_money, setTotal_debit_money] = useState(0);
    const [total_interest_received, setTotal_interest_received] = useState(0);
    const [total_loan, setTotal_loan] = useState(0);
    const [totalCapital, setTotalCapital] = useState(0);
    const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row
    const handleSelectChange = (value) => {
        setSelectedCode(value);
    };


    useEffect(() => {
        console.log("Selected code: " + selectedCode)
        fetchData();
    }, [selectedCode])

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleSearch = () => {
        fetchData();
    }

    const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;
    const fetchDataInfo = () => {
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/data-dashboard-installment`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                setTotal_interest_predict(d.total_interest_predict);
                setTotal_debit_money(d.total_debit_money);
                setTotal_interest_received(d.total_interest_received);
                setTotal_loan(d.total_loan);
                setTotalCapital(d.total_capital);
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
            });
    }

    useEffect(() => {
        fetchDataInfo();
    }, []);


    const fetchData = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (fromDate) {
            params.append('fromDate', moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        }
        if (toDate) {
            params.append('toDate', moment(toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        }

        if (txtMaHD.trim()) {
            params.append('loanId', txtMaHD.trim());
        }

        if (txtTenKH.trim()) {
            params.append('name', txtTenKH.trim());
        }

        if (txtCMND.trim()) {
            params.append('numberCard', txtCMND.trim());
        }

        if (txtPhone.trim()) {
            params.append('phone', txtPhone.trim());
        }

        params.append('code', Number(selectedCode));

        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/list-loan-installment?${params.toString()}`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                // Kiểm tra kiểu dữ liệu
                if (Array.isArray(d) || typeof d === 'object') {
                    setData(d);
                } else {
                    console.warn('Dữ liệu không hợp lệ:', d);
                    setData([]); // Thiết lập thành mảng rỗng nếu dữ liệu không hợp lệ
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
                setData([]); // Thiết lập thành mảng rỗng trong trường hợp có lỗi
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);


    const handleCloseModal = () => {
        setIsAddContract(false)
        fetchData(); // Call fetchData when the modal is closed
    };

    const handleOpenTabMenu = (tab, id) => {
        setModalContent({ tab, id });
        // console.log("==============")
        //   console.log(id)
        //   console.log("==============")
        setOpenTabMenu(true);
    };

    const handleAddContract = () => {
        setIsAddContract(true);
    };

    const handleCloseUpdate = () => {
        setIsUpdateContract(false)
        fetchData(); // Call fetchData when the modal is closed
    };

    const handleUpdateContract = (id) => {
        setModalContent((prevState) => ({
            ...prevState,  // Keep the existing tab value
            id: id,        // Update only the id
        }));
        setIsUpdateContract(true);
    };

    const columns = [
        { title: '#', dataIndex: 'index', key: 'index', render: (_, __, index) => index + 1 },
        {
            title: 'Mã HD',
            dataIndex: 'LOAN_ID',
            key: 'LOAN_ID',
            render: (text, record) => (
                <a
                    onClick={() => handleUpdateContract(record.LOAN_ID)}
                    style={{
                        color: '#007bff', // Bootstrap primary color or use another
                        fontWeight: 'bold', // Make it bold
                        textDecoration: 'underline', // Add underline
                        cursor: 'pointer' // Make it look like it's clickable
                    }}
                >
                    {text}
                </a>
            )
        },

        { title: 'Khách hàng', dataIndex: 'NAME', key: 'NAME' },
        { title: 'Tiền giao khách', dataIndex: 'TOTAL_MONEY_RECEIVED', key: 'TOTAL_MONEY_RECEIVED', render: (value) => value.toLocaleString('vi-VN') },
        {
            title: 'Thời gian',
            key: 'TotalTime',
            render: (_, record) => {
                const fromDate = new Date(record.FROM_DATE).toLocaleDateString('vi-VN', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                const toDate = new Date(record.END_DATE).toLocaleDateString('vi-VN', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                return `${fromDate} -> ${toDate}`;
            }
        },
        { title: 'Tiền đã đóng', dataIndex: 'INTEREST_MONEY_RECEIVED', key: 'INTEREST_MONEY_RECEIVED', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Nợ cũ', dataIndex: 'DEBIT_MONEY', key: 'DEBIT_MONEY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Tiền 1 ngày', dataIndex: 'MONEY_NEED_PER_PAY', key: 'MONEY_NEED_PER_PAY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Còn phải đóng', dataIndex: 'TOTAL_MONEY_NEED_PAY', key: 'TOTAL_MONEY_NEED_PAY', render: (value) => value.toLocaleString('vi-VN') },
        {
            title: 'Tình trạng', dataIndex: 'STR_STATUS', key: 'STR_STATUS', render: (status) => (
                <Tag color={status === 'Chậm họ' ? '#fcba03' : (status === 'Quá hạn' ? '#F4516C' : '#108ee9')}>{status}</Tag>
            )
        },
        { title: 'Ngày phải đóng', dataIndex: 'STR_NEXT_DATE', key: 'STR_NEXT_DATE' },


        {
            title: 'Chức năng',
            key: 'actions',
            render: (_, record) => (
                <>
                    <div>
                        <Tooltip title="Đóng tiền">
                            <Button
                                className="icon-button"
                                type="link"
                                style={{ fontSize: '20px' }}
                                onClick={() => handleOpenTabMenu("1", record.LOAN_ID)}
                                icon={<FaFileAlt style={{ color: '#fcba03' }} />}
                            />
                        </Tooltip>


                        <Tooltip title="Đóng hợp đồng">
                            <Button
                                className="icon-button"
                                type="link"
                                style={{ fontSize: '20px' }}
                                onClick={() => handleOpenTabMenu("5", record.LOAN_ID)}
                                icon={<FaAnchor style={{ color: 'green' }} />}
                            />
                        </Tooltip>

                        <Tooltip title="Xóa hợp đồng">
                            <Button
                                className="icon-button"
                                type="link"
                                style={{ fontSize: '20px' }}
                                icon={<FaTimes style={{ color: 'red' }} />}
                            />
                        </Tooltip>

                    </div>
                </>
            )

        },
    ];

    const summaryData = data.length > 0 ? data[data.length - 1] : { TotalMoney: 0, InterestMoneyReceived: 0, InterestToDay: 0 };

    const handleDownload = () => {
        setLoadingItem(true);
        const token = localStorage.getItem('token'); // Lấy token từ localStorage

        fetch(`${process.env.REACT_APP_API_DB_URL}/download-excel-installment`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                if (response.ok) {
                    return response.blob(); // Chuyển đổi dữ liệu thành blob
                }
                throw new Error('Network response was not ok.');
            })
            .then(blob => {
                saveAs(blob, 'VayLai - Báo cáo sổ quỹ tiền mặt.xlsx'); // Sử dụng file-saver để tải file về
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
            }).finally(error => {
                setLoadingItem(false);
            })
    };
    // console.log("menu tra gop")
    return (
        <div className="md:p-1">
            <h1 className="text-xl md:text-2xl font-bold mb-4">Hợp đồng Trả Góp</h1>
            <div className="flex flex-wrap justify-between gap-4 mb-4">
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">QUỸ TIỀN MẶT</p>
                    <p className="text-xl md:text-2xl font-bold">{totalCapital.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">TIỀN CHO VAY</p>
                    <p className="text-xl md:text-2xl font-bold">{total_loan.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">TIỀN NỢ</p>
                    <p className="text-xl md:text-2xl font-bold">{total_debit_money.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">LÃI DỰ KIẾN</p>
                    <p className="text-xl md:text-2xl font-bold">{total_interest_predict.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">LÃI ĐÃ THU</p>
                    <p className="text-xl md:text-2xl font-bold">{total_interest_received.toLocaleString('vi-VN')}</p>
                </div>
            </div>

            <div className="flex flex-wrap mb-4">
                <Button type="primary" className="mr-2 mb-2" onClick={handleAddContract}>Thêm mới</Button>
                {/* <Button type="default" className="mr-2 mb-2" onClick={handleDownload}>Xuất Excel</Button> */}
                <button
                    className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
                    onClick={handleDownload}
                >
                    <FaSave className="mr-2" />
                    <span>Xuất Excel</span>
                    {loadingItem && ( // Show Spin only when loading
                        <span className="ml-3">
                            <Spin indicator={whiteSpinnerIcon} />
                        </span>
                    )}
                </button>
            </div>

            <div className="flex flex-wrap mb-4">
                <Input placeholder="Tìm kiếm mã HĐ" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtMaHD} onChange={(e) => setTxtMaHD(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm tên KH" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtTenKH} onChange={(e) => setTxtTenKH(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm CMND" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtCMND} onChange={(e) => setTxtCMND(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm số điện thoại" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtPhone} onChange={(e) => setTxtPhone(e.target.value)} onKeyDown={handleKeyDown} />
                <DatePicker placeholder="Từ ngày" value={fromDate ? dayjs(fromDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                    format={'DD/MM/YYYY'}
                    onChange={(date, dateString) => {
                        setFromDate(dateString); // Update fromDate when a new date is picked
                    }} className="mr-2 mb-2 flex-1 min-w-[150px]" />
                <DatePicker placeholder="Đến ngày" value={toDate ? dayjs(toDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                    format={'DD/MM/YYYY'}
                    onChange={(date, dateString) => {
                        setToDate(dateString); // Update fromDate when a new date is picked
                    }} className="mr-2 mb-2 flex-1 min-w-[150px]" />



                <Select defaultValue="Tất cả hợp đồng đang vay" className="mr-2 mb-2 flex-1 min-w-[150px]" style={{ width: 180 }} onChange={handleSelectChange}>
                    <Option value="0">Tất cả hợp đồng đang vay</Option>
                    <Option value="1">Hợp đồng đúng hẹn</Option>
                    <Option value="2">Hợp đồng quá hạn</Option>
                    <Option value="3">Hợp đồng chậm họ</Option>
                    <Option value="500">Hợp đồng đã kết thúc</Option>
                    <Option value="501">Hợp đồng đã xóa</Option>
                    <Option value="12">Ngày mai đóng họ</Option>
                </Select>
                <Button type="primary" className="mr-2 mb-2" onClick={handleSearch}>Tìm kiếm</Button>
            </div>
            {loading ?
                (<Skeleton active />) :

                (<Table
                    className="custom-table"
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.ID}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data.length, // Tổng số dòng dữ liệu
                        onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setPageSize(pageSize);
                        },
                        showSizeChanger: true, // Hiển thị tùy chọn thay đổi số dòng
                        pageSizeOptions: [10, 20, 50, 100], // Các tùy chọn số dòng
                    }}

                    scroll={{ x: 'max-content' }} // Enable horizontal scrolling when content exceeds container width

                />)}



            <CustomModalMenu isOpen={isOpenTabMenu} onClose={() => setOpenTabMenu(false)}>
                {<TabCpn tab={modalContent.tab} id={modalContent.id} />} {/* Pass tab and id */}
            </CustomModalMenu>

            <CustomModal isOpen={isAddContract} onClose={handleCloseModal}>
                {<FrmAddContract />}
            </CustomModal>

            <CustomModal isOpen={isUpdateContract} onClose={() => setIsUpdateContract(false)}>
                {<FrmUpdateContract id={modalContent.id} />}
            </CustomModal>

        </div>
    );
};

export default MenuTraGop;
